import React from 'react';
import { connect } from 'react-redux';
import RightPanelCreate from './rightPanelCreate';
import CenterPanelCreate from './centerPanelCreate';
import RightPanelCreateBottom from './rightPanelCreateBottom';
import RightPanelUpdateBottom from './rightPanelUpdateBottom';
import RightPanelViewBottom from './rightPanelViewBottom';
import RightPanelView from './rightPanelView';
import CenterPanelView from './centerPanelView';
import RightPanelUpdate from './rightPanelUpdate';
import CenterPanelUpdate from './centerPanelUpdate';
import PopupHeader from '../../popupHeader';

@connect(mapStateToProps)
export default class CreateUpdateGroup extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      organisations: props.organisations,
      groupForm: props.groupForm,
      updateOrInsert: props.updateOrInsert,

      //  updatingGroupName: props.groupForm.name,
      //  clickedUpdateGroup: props.groupForm.clickedUpdateGroup
    };
  }

  UNSAFE_componentWillReceiveProps(props) {}

  openInsertHelp() {
    window.open(APP.EXTERNAL_LINKS.ViewGroup.HelpCreate, '_blank');
  }

  openUpdateHelp() {
    window.open(APP.EXTERNAL_LINKS.ViewGroup.HelpEditProperties, '_blank');
  }

  render() {
    let rightPanel = {};
    let rightPanelBottom = {};
    let centerPanel = {};
    let title = undefined;
    let subtitle = undefined;
    let helpFunc = undefined;
    let organisationName = this.props.groupForm.organisationName;
    let updatingGroupName =
      this.props.groupForm.headerName != undefined && this.props.groupForm.headerName != ''
        ? this.props.groupForm.headerName + ' (' + organisationName + ')'
        : '(/)';

    if (this.state.updateOrInsert == 'insert') {
      rightPanel = <RightPanelCreate groupForm={this.props.groupForm} />;
      centerPanel = <CenterPanelCreate groups={this.state.organisations} groupForm={this.props.groupForm} />;
      rightPanelBottom = <RightPanelCreateBottom />;
      helpFunc = this.openInsertHelp;
      title = APP.LANGUAGE.CreateUpdateGroup.TitleCreate;
    } else if (this.state.updateOrInsert == 'update') {
      rightPanel = <RightPanelUpdate groupForm={this.props.groupForm} />;
      centerPanel = <CenterPanelUpdate organisations={this.state.organisations} groupForm={this.props.groupForm} />;
      helpFunc = this.openUpdateHelp;
      title = APP.LANGUAGE.CreateUpdateGroup.TitleUpdate;
      subtitle = updatingGroupName;
      rightPanelBottom = <RightPanelUpdateBottom />;
    } else {
      rightPanel = <RightPanelView />;
      centerPanel = <CenterPanelView groupForm={this.props.groupForm} />;
      helpFunc = this.openUpdateHelp;
      title = APP.LANGUAGE.CreateUpdateGroup.TitleView;
      subtitle = organisationName;
      rightPanelBottom = <RightPanelViewBottom />;
    }

    return (
      <div className={'ui modal ' + this.state.updateOrInsert + '-group'}>
        <PopupHeader title={title} subtitle={subtitle} helpFunc={helpFunc} />

        <div className="content">
          <div className="main-ui-container group-create-update">
            <div id="righthandfloatingpanel">
              <div className="right ui rail">
                <div className="ui sticky">
                  {rightPanel}
                  {rightPanelBottom}
                </div>
              </div>
              {centerPanel}
              <div className="bottom-rail-with-left-and-right-content mrtl">
                {rightPanel}
                {rightPanelBottom}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    groupForm: state.groupsReducer.groupForm,
    organisations: state.organisationsReducer.organisations,
  };
}
